export const SIGN_IN = 'signin';
export const TOGGLE_SIDEBAR = 'toggleSidebar';
export const CLOSE_SIDEBAR = 'closeSidebar';
export const OPEN_SIDEBAR = 'openSidebar';
export const UPDATE_USER_DETAILS = 'upateUserDetails';
export const START_CONFETTI = 'startConfetti';
export const STOP_CONFETTI = 'stopConfetti';
export const LEARN_AUDIO = 'learnAudio';

export interface AuthDetails {
  token?: string;
  avatarUrl?: string;
  memberInformation?: any;
  organisations?: any;
  name?: string;
  authentication?: 'userInfoPending' | 'authorised' | 'unAuthorised';
  email?: string;
  isConfettiOn?: boolean;
  userId?: string;
}

export interface LearnDetails {
  learnAudio?: HTMLAudioElement;
}
